// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
window.commonLogan = (require('./request/loganMethod')).commonLogan;
import apis from './request/apis'
import './commonjs/vuePrototype.js';
import "./iconfont/iconfont.js";
import { NavBar, Dialog, Toast } from 'vant';
import store from './vuex/store';
window.commonObj = (require('@/commonjs/common.js')).commonObj;
// window.areaMapObj = (require('@/commonjs/areaMap.js')).areaMapObj;
window.projectRuleObj = (require('@/commonjs/projectRule.js')).projectRuleObj;
window.utilsObj = (require('@/commonjs/utils.js')).utilsObj;
window.uploadFileObj = (require('@/commonjs/uploadFile.js')).uploadFileObj;
import VuePageStack from 'vue-page-stack';
import APlayer from '@moefe/vue-aplayer';

import QrcodeV2 from 'qrcode-v2';

Vue.use(QrcodeV2);

import markdownIt from 'markdown-it';
const md = markdownIt();
md.use(require('markdown-it-lazy-headers'));

import Meta from "vue-meta";
Vue.use(Meta);

import waterfall from 'vue-waterfall2';
Vue.use(waterfall);

Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.prototype.$api = apis;

Vue.use(NavBar);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(VuePageStack, { router });
Vue.use(APlayer, {
  defaultCover: '',
  productionTip: true,
});

import AMap from 'vue-amap';
Vue.use(AMap);
window._AMapSecurityConfig = {
	//serviceHost: '',
	securityJsCode: 'b0e15ef8871b63452afc26152627882c',//'c45adea4cf9b21e9fd4b8d687609bbe0',
}
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '72899804ef76c30b8a13fa5a45c27986',//'71c6a57b779b2655b80412c47378aba8',
  // 插件集合 （插件按需引入）
  plugin: ['AMap.Geolocation', 'AMap.Autocomplete', "AMap.Geocoder",'AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
 
});
store.state.stateObject.tokenRefreshTime=new Date();
var index = navigator.userAgent.split(" ").length;
// if (navigator.userAgent.split(" ")[index - 1].length < 30) {
if (navigator.userAgent.indexOf("os-name/android")==-1) {
  if (process.env.NODE_ENV === "development"||process.env.NODE_ENV === "testing") {
    var userInfo1 ={
    "staffId": "df00b9ab6ebc3ab01753f8e00a4b9409",
    "companyId": "0201b4ab530b9ffe2fe72152fe4ab195",
    "companyName": "成都总公司",
    "jobState": 2,
    "roleLevelName": "",
    "name": "黄芳",
    "phone": "15520666666",
    "pwd": null,
    "headPic": "http://oss.mfzcw.com/image/heardImgb99dfeb4-c791-4369-b3e8-0f89cef90452.png",
    "pic": "",
    "entryDate": null,
    "state": 0,
    "deptId": 110,
    "expandManage": null,
    "actions": null,
    "roleList": null,
    "map": null,
    "commentStaffId": null,
    "commentStaffName": null,
    "busPhone": "18782004619",
    "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJjb21wYW55SWQiOiIwMjAxYjRhYjUzMGI5ZmZlMmZlNzIxNTJmZTRhYjE5NSIsImxvZ2luTmFtZSI6IjE1NTIwNjY2NjY2Iiwic3RhZmZOYW1lIjoi6buE6IqzIiwic3RhZmZJZCI6ImRmMDBiOWFiNmViYzNhYjAxNzUzZjhlMDBhNGI5NDA5IiwiaWF0IjoxNzc4MjI1NTI5LCJleHAiOjE3NzgzMTE5MjksIm5iZiI6MTc3ODIyNTUyOX0.S5fRD76TwStPi0Wjrw7oYHAAaz4zAU2wCA0rin331Ug",
    "deviceNumber": "1312",
    "isOpen": 1,
    "isFaceClockIn": null,
    "sts": [],
    "isWatermark": 1,
    "collectName": null,
    "companyRoleResps": [
      {
        "companyId": "0201b4ab530b9ffe2fe72152fe4ab195",
        "companyName": "成都总公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "logPositionSearch",
          "showLog",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "managerSend",
          "projectSetting",
          "manangerLogin",
          "callPhone",
          "writeFollowUp",
          "updateFee",
          "editCustomServiceFee",
          "enditBySignPass",
          "enditBloneStaff",
          "salesScreen",
          "isSetFalseState",
          "moreSetLable",
          "projectLost",
          "projectHandOver",
          "showGoodNewsStory",
          "showWaitFollowUp",
          "searchOtherDataWaitFollowUp",
          "submitBeOverdue",
          "submitBeOverdueFollowup",
          "submitBeOverdueRecord",
          "showPropagandaGift",
          "giveGift",
          "showProjectCheckList",
          "showIsNoObjectSecondSureEdit",
          "objectCompletCheck",
          "supportMeritAndShortcoming",
          "paymentList",
          "proprietorMsg",
          "refundPKApply",
          "speechcraftListEdit",
          "showDetentionBtn",
          "serviceAgreementApplyList",
          "serviceAgreementAuditList",
          "showServiceRecord",
          "speechcraftCollectAdd",
          "speechcraftReferToOrAdopt",
          "ProjectFlowAudit",
          "dataBoard",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 1,
            "roleLevel": 0,
            "roleName": "总公司",
            "actions": [
              "logPositionSearch",
              "showLog"
            ]
          },
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          },
          {
            "roleId": 31,
            "roleLevel": 3,
            "roleName": "部长",
            "actions": [
              "projectEdit",
              "devInfo",
              "managerSend",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectSetting",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "manangerLogin",
              "showProjectProcess",
              "callPhone",
              "writeFollowUp",
              "updateFee",
              "showCustomList",
              "editCustomServiceFee",
              "searchOtherDataCustomList",
              "enditBySignPass",
              "enditBloneStaff",
              "salesScreen",
              "showCarportList",
              "editCarSetIsSale",
              "isSetFalseState",
              "moreSetLable",
              "projectLost",
              "showProjectInventory",
              "projectHandOver",
              "adjustStaff",
              "showAssignList",
              "pressForMoneyList",
              "showGoodNewsStory",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitFollowUp",
              "searchOtherDataWaitFollowUp",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "statisticsDetailPerson",
              "showStatistics",
              "submitBeOverdue",
              "submitBeOverdueFollowup",
              "submitBeOverdueRecord",
              "logPositionSearch",
              "showLog",
              "showPropagandaGift",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "giveGift",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showProjectCheckList",
              "showIsNoObjectSecondSureEdit",
              "objectCompletCheck",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "OAInport",
              "supportMeritAndShortcoming",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "showManager",
              "showManagerSale",
              "showManagerProject",
              "projectMsg",
              "proprietorMsg",
              "stockMsg",
              "showProjectPKList",
              "refundPKApply",
              "showsurveyByQuestionnaireList",
              "speechcraftList",
              "speechcraftListEdit",
              "speechcraftAuditList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "serviceAgreementApplyList",
              "serviceAgreementAuditList",
              "showCollectProject",
              "showToDoListSale",
              "showServiceRecord",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "allPracticeOrPassWeek",
              "speechcraftCollectList",
              "speechcraftCollectAdd",
              "speechcraftReferToOrAdopt",
              "ProjectFlowAudit",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "showActorClockIn",
              "startActorClockIn",
              "dataBoard"
            ]
          }
        ],
        "longitude": 104.07,
        "latitude": 30.65
      },
      {
        "companyId": "f98b8437816f499db495e02caac49ace",
        "companyName": "安徽分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "logPositionSearch",
          "showLog",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "managerSend",
          "projectSetting",
          "manangerLogin",
          "callPhone",
          "writeFollowUp",
          "updateFee",
          "editCustomServiceFee",
          "enditBySignPass",
          "enditBloneStaff",
          "salesScreen",
          "isSetFalseState",
          "moreSetLable",
          "projectLost",
          "projectHandOver",
          "showGoodNewsStory",
          "showWaitFollowUp",
          "searchOtherDataWaitFollowUp",
          "submitBeOverdue",
          "submitBeOverdueFollowup",
          "submitBeOverdueRecord",
          "showPropagandaGift",
          "giveGift",
          "showProjectCheckList",
          "showIsNoObjectSecondSureEdit",
          "objectCompletCheck",
          "supportMeritAndShortcoming",
          "paymentList",
          "proprietorMsg",
          "refundPKApply",
          "speechcraftListEdit",
          "showDetentionBtn",
          "serviceAgreementApplyList",
          "serviceAgreementAuditList",
          "showServiceRecord",
          "speechcraftCollectAdd",
          "speechcraftReferToOrAdopt",
          "ProjectFlowAudit",
          "dataBoard",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 1,
            "roleLevel": 0,
            "roleName": "总公司",
            "actions": [
              "logPositionSearch",
              "showLog"
            ]
          },
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          },
          {
            "roleId": 31,
            "roleLevel": 3,
            "roleName": "部长",
            "actions": [
              "projectEdit",
              "devInfo",
              "managerSend",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectSetting",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "manangerLogin",
              "showProjectProcess",
              "callPhone",
              "writeFollowUp",
              "updateFee",
              "showCustomList",
              "editCustomServiceFee",
              "searchOtherDataCustomList",
              "enditBySignPass",
              "enditBloneStaff",
              "salesScreen",
              "showCarportList",
              "editCarSetIsSale",
              "isSetFalseState",
              "moreSetLable",
              "projectLost",
              "showProjectInventory",
              "projectHandOver",
              "adjustStaff",
              "showAssignList",
              "pressForMoneyList",
              "showGoodNewsStory",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitFollowUp",
              "searchOtherDataWaitFollowUp",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "statisticsDetailPerson",
              "showStatistics",
              "submitBeOverdue",
              "submitBeOverdueFollowup",
              "submitBeOverdueRecord",
              "logPositionSearch",
              "showLog",
              "showPropagandaGift",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "giveGift",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showProjectCheckList",
              "showIsNoObjectSecondSureEdit",
              "objectCompletCheck",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "OAInport",
              "supportMeritAndShortcoming",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "showManager",
              "showManagerSale",
              "showManagerProject",
              "projectMsg",
              "proprietorMsg",
              "stockMsg",
              "showProjectPKList",
              "refundPKApply",
              "showsurveyByQuestionnaireList",
              "speechcraftList",
              "speechcraftListEdit",
              "speechcraftAuditList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "serviceAgreementApplyList",
              "serviceAgreementAuditList",
              "showCollectProject",
              "showToDoListSale",
              "showServiceRecord",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "allPracticeOrPassWeek",
              "speechcraftCollectList",
              "speechcraftCollectAdd",
              "speechcraftReferToOrAdopt",
              "ProjectFlowAudit",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "showActorClockIn",
              "startActorClockIn",
              "dataBoard"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "af07b64b43434b08b391867871276d2f",
        "companyName": "重庆分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "logPositionSearch",
          "showLog",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "supportMeritAndShortcoming",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "paymentList",
          "proprietorMsg",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          }
        ],
        "longitude": 106.541081,
        "latitude": 29.552407
      },
      {
        "companyId": "eb2e6d9087744ab48d690ab26198b50f",
        "companyName": "贵州分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListSalesSecretary",
          "projectListAllMisnister",
          "headBanner",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "addPressMoneyDev",
          "showOAHandle",
          "logPositionSearch",
          "showLog",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showExpandLog",
          "showExpandPositionSearch",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "betweenTwoPartiesList",
          "showPaymentApproved",
          "showSalesList",
          "pressForDepositMoneyList",
          "OAInport",
          "selectDailyWTR",
          "selectPayWTR",
          "supportMeritAndShortcoming",
          "inviteSupport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantApply",
          "merchantAudit",
          "merchantPassList",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "proCustomerServiceFee",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "changeTaskProjectList",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaDaylyApplyImport",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "auditMoreDataForOA",
          "OADevInport",
          "showInterviewRecording",
          "filterExpandStaff",
          "showSheetData",
          "paymentList",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "proprietorMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "collectionMsg",
          "selfMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "pressForDepositMoneyListDev",
          "contactDelay",
          "advancePayment",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "showDevProjectPKList",
          "monthlyReview",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "borrowingRecords",
          "borrowingRecordsDev",
          "contractList",
          "devScoreList",
          "mortgageDocumentList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "bankAccountBalance",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "importantToDoListDev",
          "replayRecord",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "216d3310b6c5425191393fd973f376dc",
        "companyName": "贵州分公司1",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "logPositionSearch",
          "showLog",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "supportMeritAndShortcoming",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "paymentList",
          "proprietorMsg",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "8253927dbcc144afb420187a938dc753",
        "companyName": "湖北分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "logPositionSearch",
          "showLog",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "supportMeritAndShortcoming",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "paymentList",
          "proprietorMsg",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "1ea8cab97dd14014a672b53e06f530f1",
        "companyName": "江西分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "logPositionSearch",
          "showLog",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "managerSend",
          "projectSetting",
          "manangerLogin",
          "callPhone",
          "writeFollowUp",
          "updateFee",
          "editCustomServiceFee",
          "enditBySignPass",
          "enditBloneStaff",
          "salesScreen",
          "isSetFalseState",
          "moreSetLable",
          "projectLost",
          "projectHandOver",
          "showGoodNewsStory",
          "showWaitFollowUp",
          "searchOtherDataWaitFollowUp",
          "submitBeOverdue",
          "submitBeOverdueFollowup",
          "submitBeOverdueRecord",
          "showPropagandaGift",
          "giveGift",
          "showProjectCheckList",
          "showIsNoObjectSecondSureEdit",
          "objectCompletCheck",
          "supportMeritAndShortcoming",
          "paymentList",
          "proprietorMsg",
          "refundPKApply",
          "speechcraftListEdit",
          "showDetentionBtn",
          "serviceAgreementApplyList",
          "serviceAgreementAuditList",
          "showServiceRecord",
          "speechcraftCollectAdd",
          "speechcraftReferToOrAdopt",
          "ProjectFlowAudit",
          "dataBoard",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 1,
            "roleLevel": 0,
            "roleName": "总公司",
            "actions": [
              "logPositionSearch",
              "showLog"
            ]
          },
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          },
          {
            "roleId": 31,
            "roleLevel": 3,
            "roleName": "部长",
            "actions": [
              "projectEdit",
              "devInfo",
              "managerSend",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectSetting",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "manangerLogin",
              "showProjectProcess",
              "callPhone",
              "writeFollowUp",
              "updateFee",
              "showCustomList",
              "editCustomServiceFee",
              "searchOtherDataCustomList",
              "enditBySignPass",
              "enditBloneStaff",
              "salesScreen",
              "showCarportList",
              "editCarSetIsSale",
              "isSetFalseState",
              "moreSetLable",
              "projectLost",
              "showProjectInventory",
              "projectHandOver",
              "adjustStaff",
              "showAssignList",
              "pressForMoneyList",
              "showGoodNewsStory",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitFollowUp",
              "searchOtherDataWaitFollowUp",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "statisticsDetailPerson",
              "showStatistics",
              "submitBeOverdue",
              "submitBeOverdueFollowup",
              "submitBeOverdueRecord",
              "logPositionSearch",
              "showLog",
              "showPropagandaGift",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "giveGift",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showProjectCheckList",
              "showIsNoObjectSecondSureEdit",
              "objectCompletCheck",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "OAInport",
              "supportMeritAndShortcoming",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "showManager",
              "showManagerSale",
              "showManagerProject",
              "projectMsg",
              "proprietorMsg",
              "stockMsg",
              "showProjectPKList",
              "refundPKApply",
              "showsurveyByQuestionnaireList",
              "speechcraftList",
              "speechcraftListEdit",
              "speechcraftAuditList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "serviceAgreementApplyList",
              "serviceAgreementAuditList",
              "showCollectProject",
              "showToDoListSale",
              "showServiceRecord",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "allPracticeOrPassWeek",
              "speechcraftCollectList",
              "speechcraftCollectAdd",
              "speechcraftReferToOrAdopt",
              "ProjectFlowAudit",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "showActorClockIn",
              "startActorClockIn",
              "dataBoard"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "0d4e1dcab6044b59966e333013270330",
        "companyName": "内蒙古分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "logPositionSearch",
          "showLog",
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "managerSend",
          "projectSetting",
          "manangerLogin",
          "callPhone",
          "writeFollowUp",
          "updateFee",
          "editCustomServiceFee",
          "enditBySignPass",
          "enditBloneStaff",
          "salesScreen",
          "isSetFalseState",
          "moreSetLable",
          "projectLost",
          "projectHandOver",
          "showGoodNewsStory",
          "showWaitFollowUp",
          "searchOtherDataWaitFollowUp",
          "submitBeOverdue",
          "submitBeOverdueFollowup",
          "submitBeOverdueRecord",
          "showPropagandaGift",
          "giveGift",
          "showProjectCheckList",
          "showIsNoObjectSecondSureEdit",
          "objectCompletCheck",
          "supportMeritAndShortcoming",
          "paymentList",
          "proprietorMsg",
          "refundPKApply",
          "speechcraftListEdit",
          "showDetentionBtn",
          "serviceAgreementApplyList",
          "serviceAgreementAuditList",
          "showServiceRecord",
          "speechcraftCollectAdd",
          "speechcraftReferToOrAdopt",
          "ProjectFlowAudit",
          "dataBoard",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 1,
            "roleLevel": 0,
            "roleName": "总公司",
            "actions": [
              "logPositionSearch",
              "showLog"
            ]
          },
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          },
          {
            "roleId": 31,
            "roleLevel": 3,
            "roleName": "部长",
            "actions": [
              "projectEdit",
              "devInfo",
              "managerSend",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectSetting",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "manangerLogin",
              "showProjectProcess",
              "callPhone",
              "writeFollowUp",
              "updateFee",
              "showCustomList",
              "editCustomServiceFee",
              "searchOtherDataCustomList",
              "enditBySignPass",
              "enditBloneStaff",
              "salesScreen",
              "showCarportList",
              "editCarSetIsSale",
              "isSetFalseState",
              "moreSetLable",
              "projectLost",
              "showProjectInventory",
              "projectHandOver",
              "adjustStaff",
              "showAssignList",
              "pressForMoneyList",
              "showGoodNewsStory",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitFollowUp",
              "searchOtherDataWaitFollowUp",
              "showWaitCheck",
              "showOAHandle",
              "showWithdrawalList",
              "statisticsDetailPerson",
              "showStatistics",
              "submitBeOverdue",
              "submitBeOverdueFollowup",
              "submitBeOverdueRecord",
              "logPositionSearch",
              "showLog",
              "showPropagandaGift",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "giveGift",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "showPendingCashCollection",
              "showProjectCheckList",
              "showIsNoObjectSecondSureEdit",
              "objectCompletCheck",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "OAInport",
              "supportMeritAndShortcoming",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "showManager",
              "showManagerSale",
              "showManagerProject",
              "projectMsg",
              "proprietorMsg",
              "stockMsg",
              "showProjectPKList",
              "refundPKApply",
              "showsurveyByQuestionnaireList",
              "speechcraftList",
              "speechcraftListEdit",
              "speechcraftAuditList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "serviceAgreementApplyList",
              "serviceAgreementAuditList",
              "showCollectProject",
              "showToDoListSale",
              "showServiceRecord",
              "showReviewedRecommender",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "allPracticeOrPassWeek",
              "speechcraftCollectList",
              "speechcraftCollectAdd",
              "speechcraftReferToOrAdopt",
              "ProjectFlowAudit",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "showActorClockIn",
              "startActorClockIn",
              "dataBoard"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      },
      {
        "companyId": "cf384ef2b4f24d3795e00e27f6c14125",
        "companyName": "西安分公司",
        "roleId": null,
        "staffId": null,
        "actions": [
          "projectListAllManager",
          "projectEdit",
          "devInfo",
          "addEntrance",
          "updateEntrance",
          "showProjectList",
          "businessTermContract",
          "projectListSalesSecretary",
          "projectInport",
          "projectListAllMisnister",
          "headBanner",
          "workBordContractManage",
          "showProjectProcess",
          "showCustomList",
          "searchOtherDataCustomList",
          "showCarportList",
          "editCarSetIsSale",
          "addParkingPlace",
          "showProjectInventory",
          "adjustStaff",
          "showAssignList",
          "showManagerTeam",
          "teamChangeRefundPK",
          "changAllData",
          "endPressMoney",
          "pressForMoneyList",
          "PressByProject",
          "endPressMoneyDev",
          "pressForMoneyListDev",
          "showFollowUpRecords",
          "searchOtherDataFollowUpRecords",
          "showWaitCheck",
          "showOAHandle",
          "showWaitReceive",
          "showWithdrawalList",
          "showWaitDistribution",
          "statisticsDetailManager",
          "statisticsDetailPerson",
          "statisticsDetailTimes",
          "showStatistics",
          "export",
          "wechartDataTotal",
          "logPositionSearch",
          "showLog",
          "showExpandLog",
          "showExpandPositionSearch",
          "showProjectProductOutputValue",
          "showCheckWork",
          "scoreDifficultyTable",
          "projectOpeningTable",
          "projectStandardTable",
          "betweenTwoPartiesList",
          "showGiftCheckList",
          "showManagerPerson",
          "showCallRecordsForStaffAll",
          "recordingRecommendation1",
          "recordingRecommendation2",
          "recordingRecommendation3",
          "highQualityRecording",
          "showPendingCashCollection",
          "showSalesList",
          "showPreferentialConditions",
          "pressForDepositMoneyList",
          "contactDelay",
          "OAInport",
          "personnelTransfer",
          "OaWeekPlant",
          "merchantPassList",
          "lostOrReportedLoss",
          "customerMaintenanceRecommendAudit",
          "proCustomerServiceFee",
          "changeTaskProjectList",
          "oaDaylyApplyImport",
          "auditMoreDataForOA",
          "OADevInport",
          "showSheetData",
          "showDailyReport",
          "sendGiftMore",
          "showSalaryRank",
          "showTraversallntegral",
          "showCapabilityCoefficient",
          "showManager",
          "showManagerRevenue",
          "showManagerSale",
          "showManagerProject",
          "competitor",
          "projectMsg",
          "signingMsg",
          "stockMsg",
          "resourcesMsg",
          "financeMsg",
          "parkingLotMsg",
          "staffMsg",
          "selfMsg",
          "pressForDepositMoneyListDev",
          "showWorkOrder",
          "showProjectPKList",
          "auditPKList",
          "auditPKBotton",
          "auditPKListCompanySearch",
          "showDevProjectPKList",
          "showsurveyByQuestionnaireList",
          "investigateReport",
          "speechcraftList",
          "speechcraftAuditList",
          "friendCircleMaterialSale",
          "borrowingRecords",
          "borrowingRecordsDev",
          "devScoreList",
          "mortgageDocumentList",
          "showCollectProject",
          "showToDoListSale",
          "proprietorChatList",
          "showReviewedRecommender",
          "withdrawalTimeAudit",
          "showProjectInventoryForPersonal",
          "practiseEveryDay",
          "practiseEveryWeek",
          "passEveryWeek",
          "studyMap",
          "collegeTask",
          "newComerMentoringInport",
          "allPracticeOrPassWeek",
          "videoList",
          "speechcraftCollectList",
          "bankAccountBalance",
          "showWarehouseManage",
          "showInventoryleaveUnusedList",
          "showTransitReserveListList",
          "showSaleProcess",
          "importantToDoListDev",
          "addMinistersPatrol",
          "showMinistersPatrol",
          "replayRecord",
          "showActorClockIn",
          "startActorClockIn",
          "actionWXList",
          "createdActionForAll",
          "outputValueMap",
          "showOtherMoudle",
          "addPressMoneyDev",
          "showExpandProjectList",
          "showDeleteBotton",
          "showProjectAuditMarkPerson",
          "showExpandProjectFollow",
          "showExpandResList",
          "searchResListPerson",
          "showDeleteResourceBotton",
          "showDevRecordingSelect",
          "showExpandResFollow",
          "searchResFollow",
          "showExpandPersonInventory",
          "showExpandStatistics",
          "showExpandProjectWaitFollow",
          "showResWaitFollow",
          "showClause",
          "showExpandContract",
          "showExpandWaitReceive",
          "showRecordingModule",
          "searchOther",
          "showResourceGiftList",
          "showSearchList",
          "showDevelopers",
          "searchOtherDV",
          "showBond",
          "showPaymentApproved",
          "selectDailyWTR",
          "selectPayWTR",
          "supportMeritAndShortcoming",
          "inviteSupport",
          "merchantApply",
          "merchantAudit",
          "merchantSettlementAuditManager",
          "merchantSettlementAuditPurchase",
          "customerMaintenanceRecommend",
          "goodsConsumingForProject",
          "reserveTransitScanList",
          "OaPurchase",
          "ZWAudit",
          "startAdvertisingApply",
          "advertisingApplyAudit",
          "advertisingApply",
          "goodsConsumingAuditList",
          "selfInstallList",
          "oaPaymentApplyImport",
          "applyCarmanagerFee",
          "applyPromiseFee",
          "showInterviewRecording",
          "filterExpandStaff",
          "paymentList",
          "proprietorMsg",
          "collectionMsg",
          "helpMsg",
          "infoShareMsg",
          "beeAIMsg",
          "advancePayment",
          "monthlyReview",
          "developerToBeSupplemented",
          "businessTermsList",
          "showCallCenterList",
          "friendCircleMaterialExpand",
          "contractList",
          "showDetentionBtn",
          "showMortgageDocument",
          "showDetentionBtnDev",
          "replayList",
          "deliver",
          "proCustomerServiceFeeExpand",
          "showToDoList",
          "showExpandCollectProject",
          "showCommercialTerms",
          "showDraftContractList",
          "showCommercialTermsList",
          "showWithdrawalMeeting",
          "ProjectFlowAudit",
          "propertyToBeSupplemented",
          "showDevelopPKList",
          "showsurveyByQuestionnaireListDev",
          "scanStreetDev",
          "expectSignProjectList",
          "expectSignProjectListOther",
          "reserveProjectsList",
          "resourceTransmitList",
          "replayRecordDev",
          "infoShareList",
          "projectAuditList",
          "cooperationInfoBoard",
          "meetingManageDev",
          "publicAreaResourceList",
          "scheduleListPersonSearch",
          "customerMagAllPerson",
          "showCustomersImport",
          "businessCardRelated",
          "businessCardEntrance",
          "businessCardDynamicListEntrance",
          "developerReceptionList",
          "workPlanListPersonSearch",
          "resourceRecommendList",
          "resourceVerifyList",
          "noWorkPlanList",
          "monthTagAllPerson",
          "groupFourBusinessSearchPerson"
        ],
        "roleList": [
          {
            "roleId": 3,
            "roleLevel": 2,
            "roleName": "拓展总监",
            "actions": [
              "projectListSalesSecretary",
              "projectListAllMisnister",
              "headBanner",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "addPressMoneyDev",
              "showOAHandle",
              "logPositionSearch",
              "showLog",
              "showExpandProjectList",
              "showDeleteBotton",
              "showProjectAuditMarkPerson",
              "showExpandProjectFollow",
              "showExpandResList",
              "searchResListPerson",
              "showDeleteResourceBotton",
              "showDevRecordingSelect",
              "showExpandResFollow",
              "searchResFollow",
              "showExpandPersonInventory",
              "showExpandStatistics",
              "showExpandProjectWaitFollow",
              "showResWaitFollow",
              "showClause",
              "showExpandContract",
              "showExpandWaitReceive",
              "showExpandLog",
              "showExpandPositionSearch",
              "showRecordingModule",
              "searchOther",
              "showResourceGiftList",
              "showSearchList",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "showDevelopers",
              "searchOtherDV",
              "showBond",
              "betweenTwoPartiesList",
              "showPaymentApproved",
              "showSalesList",
              "pressForDepositMoneyList",
              "OAInport",
              "selectDailyWTR",
              "selectPayWTR",
              "supportMeritAndShortcoming",
              "inviteSupport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantApply",
              "merchantAudit",
              "merchantPassList",
              "merchantSettlementAuditManager",
              "merchantSettlementAuditPurchase",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "customerMaintenanceRecommend",
              "goodsConsumingForProject",
              "proCustomerServiceFee",
              "reserveTransitScanList",
              "OaPurchase",
              "ZWAudit",
              "startAdvertisingApply",
              "advertisingApplyAudit",
              "advertisingApply",
              "changeTaskProjectList",
              "goodsConsumingAuditList",
              "selfInstallList",
              "oaDaylyApplyImport",
              "oaPaymentApplyImport",
              "applyCarmanagerFee",
              "applyPromiseFee",
              "auditMoreDataForOA",
              "OADevInport",
              "showInterviewRecording",
              "filterExpandStaff",
              "showSheetData",
              "paymentList",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "proprietorMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "collectionMsg",
              "selfMsg",
              "helpMsg",
              "infoShareMsg",
              "beeAIMsg",
              "pressForDepositMoneyListDev",
              "contactDelay",
              "advancePayment",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "showDevProjectPKList",
              "monthlyReview",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "developerToBeSupplemented",
              "businessTermsList",
              "showCallCenterList",
              "friendCircleMaterialExpand",
              "borrowingRecords",
              "borrowingRecordsDev",
              "contractList",
              "devScoreList",
              "mortgageDocumentList",
              "showDetentionBtn",
              "showMortgageDocument",
              "showDetentionBtnDev",
              "replayList",
              "deliver",
              "proCustomerServiceFeeExpand",
              "showToDoList",
              "showExpandCollectProject",
              "showCommercialTerms",
              "showDraftContractList",
              "showCommercialTermsList",
              "showWithdrawalMeeting",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "bankAccountBalance",
              "ProjectFlowAudit",
              "propertyToBeSupplemented",
              "showDevelopPKList",
              "importantToDoListDev",
              "replayRecord",
              "showsurveyByQuestionnaireListDev",
              "scanStreetDev",
              "expectSignProjectList",
              "expectSignProjectListOther",
              "reserveProjectsList",
              "resourceTransmitList",
              "replayRecordDev",
              "infoShareList",
              "projectAuditList",
              "cooperationInfoBoard",
              "meetingManageDev",
              "publicAreaResourceList",
              "scheduleListPersonSearch",
              "customerMagAllPerson",
              "showCustomersImport",
              "businessCardRelated",
              "businessCardEntrance",
              "businessCardDynamicListEntrance",
              "developerReceptionList",
              "workPlanListPersonSearch",
              "resourceRecommendList",
              "resourceVerifyList",
              "noWorkPlanList",
              "monthTagAllPerson",
              "groupFourBusinessSearchPerson"
            ]
          },
          {
            "roleId": 4,
            "roleLevel": 2,
            "roleName": "销售总监",
            "actions": [
              "projectListAllManager",
              "projectEdit",
              "devInfo",
              "addEntrance",
              "updateEntrance",
              "showProjectList",
              "businessTermContract",
              "projectListSalesSecretary",
              "projectInport",
              "projectListAllMisnister",
              "headBanner",
              "workBordContractManage",
              "showProjectProcess",
              "showCustomList",
              "searchOtherDataCustomList",
              "showCarportList",
              "editCarSetIsSale",
              "addParkingPlace",
              "showProjectInventory",
              "adjustStaff",
              "showAssignList",
              "showManagerTeam",
              "teamChangeRefundPK",
              "changAllData",
              "endPressMoney",
              "pressForMoneyList",
              "PressByProject",
              "endPressMoneyDev",
              "pressForMoneyListDev",
              "showFollowUpRecords",
              "searchOtherDataFollowUpRecords",
              "showWaitCheck",
              "showOAHandle",
              "showWaitReceive",
              "showWithdrawalList",
              "showWaitDistribution",
              "statisticsDetailManager",
              "statisticsDetailPerson",
              "statisticsDetailTimes",
              "showStatistics",
              "export",
              "wechartDataTotal",
              "logPositionSearch",
              "showLog",
              "showExpandLog",
              "showExpandPositionSearch",
              "showProjectProductOutputValue",
              "showCheckWork",
              "scoreDifficultyTable",
              "projectOpeningTable",
              "projectStandardTable",
              "betweenTwoPartiesList",
              "showGiftCheckList",
              "showManagerPerson",
              "showCallRecordsForStaffAll",
              "recordingRecommendation1",
              "recordingRecommendation2",
              "recordingRecommendation3",
              "highQualityRecording",
              "showPendingCashCollection",
              "showSalesList",
              "showPreferentialConditions",
              "pressForDepositMoneyList",
              "contactDelay",
              "OAInport",
              "personnelTransfer",
              "OaWeekPlant",
              "merchantPassList",
              "lostOrReportedLoss",
              "customerMaintenanceRecommendAudit",
              "proCustomerServiceFee",
              "changeTaskProjectList",
              "oaDaylyApplyImport",
              "auditMoreDataForOA",
              "OADevInport",
              "showSheetData",
              "showDailyReport",
              "sendGiftMore",
              "showSalaryRank",
              "showTraversallntegral",
              "showCapabilityCoefficient",
              "showManager",
              "showManagerRevenue",
              "showManagerSale",
              "showManagerProject",
              "competitor",
              "projectMsg",
              "signingMsg",
              "stockMsg",
              "resourcesMsg",
              "financeMsg",
              "parkingLotMsg",
              "staffMsg",
              "selfMsg",
              "pressForDepositMoneyListDev",
              "showWorkOrder",
              "showProjectPKList",
              "auditPKList",
              "auditPKBotton",
              "auditPKListCompanySearch",
              "showDevProjectPKList",
              "showsurveyByQuestionnaireList",
              "investigateReport",
              "speechcraftList",
              "speechcraftAuditList",
              "friendCircleMaterialSale",
              "borrowingRecords",
              "borrowingRecordsDev",
              "devScoreList",
              "mortgageDocumentList",
              "showCollectProject",
              "showToDoListSale",
              "proprietorChatList",
              "showReviewedRecommender",
              "withdrawalTimeAudit",
              "showProjectInventoryForPersonal",
              "practiseEveryDay",
              "practiseEveryWeek",
              "passEveryWeek",
              "studyMap",
              "collegeTask",
              "newComerMentoringInport",
              "allPracticeOrPassWeek",
              "videoList",
              "speechcraftCollectList",
              "bankAccountBalance",
              "showWarehouseManage",
              "showInventoryleaveUnusedList",
              "showTransitReserveListList",
              "showSaleProcess",
              "importantToDoListDev",
              "addMinistersPatrol",
              "showMinistersPatrol",
              "replayRecord",
              "showActorClockIn",
              "startActorClockIn",
              "actionWXList",
              "createdActionForAll",
              "outputValueMap",
              "showOtherMoudle"
            ]
          }
        ],
        "longitude": null,
        "latitude": null
      }
    ],
    "nickName": null,
    "masterCompanyId": "0201b4ab530b9ffe2fe72152fe4ab195",
    "masterCompanyName": "成都总公司",
    "qrCode": null,
    "pstaffId": "0"
  }
  if(localStorage.getItem("TDY")){
    userInfo1=JSON.parse(localStorage.getItem("TDY"));
  }
  
  
    userInfo1.actions=userInfo1.companyRoleResps[0].actions;
      userInfo1.roleList=userInfo1.companyRoleResps[0].roleList;
      ;//JSON.parse(userInfoJson);
    let obj = { userInfo: userInfo1 };
    store.commit("stateFn", obj);
  } else {
    let obj = { userInfo: {} };
    store.commit("stateFn", obj);
  }
  new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
}).$mount('#app');
} else {
  function reloadAgin(isCountinue){
    SXApi.call(
      function (suc) {
        if (suc.data && suc.data.data) {
          localStorage.setItem(
            "thisProjectInfo",
            suc.data.data
          );
        }
      },
      null,
      "FunctionPlugin",
      "get_location",
      {
        key: "thisProjectInfo",
      }
    );
    SXApi.call(
      function (suc) {
        if (suc.data && suc.data.data) {
          let userInfo1 = JSON.parse(suc.data.data);
          let obj = { userInfo: userInfo1 };
          store.commit("stateFn", obj);
          new Vue({
            el: '#app',
            router,
            store,
            render: h => h(App),
          }).$mount('#app');
        }else{
          Toast("失败");
          // if(isCountinue){
          //   setTimeout(() => {
          //     reloadAgin(false);
          //   }, 200);
          // }
        }
  
      },
      null,
      "FunctionPlugin",
      "get_location",
      {
        key: "userInfo",
      }
    );
  }
  //var userInfoJson = navigator.userAgent.split(" ")[index - 1];
  //var userInfo1 = JSON.parse(userInfoJson);
  // let obj = { userInfo: userInfo1 };
  // store.commit("stateFn", obj);

  // var thisProjectInfo = navigator.userAgent.split(" ")[index - 2];
  // localStorage.setItem(
  //   "thisProjectInfo",
  //   thisProjectInfo
  // );
  document.addEventListener('deviceready',function(){
    reloadAgin(true);
  },false);

  
  
  // SXApi.call(
  //   function (suc) {
  //     if (suc.data && suc.data.data) {
  //       localStorage.setItem(
  //         "thisProjectInfo",
  //         suc.data.data
  //       );
  //     }
  //   },
  //   null,
  //   "FunctionPlugin",
  //   "get_location",
  //   {
  //     key: "thisProjectInfo",
  //   }
  // );
  // SXApi.call(
  //   function (suc) {
  //     if (suc.data && suc.data.data) {
  //       try {
  //       let userInfo1 = JSON.parse(suc.data.data);
  //       let obj = { userInfo: userInfo1 };
  //       store.commit("stateFn", obj);
  //       new Vue({
  //         el: '#app',
  //         router,
  //         store,
  //         render: h => h(App),
  //       }).$mount('#app');
  //     } catch (error) {
  //       alert("解析失败"+suc.data.data);
  //       reloadAgin()
  //     }
  //     }else{
  //       alert("失败")
  //       reloadAgin()
  //     }

  //   },
  //   null,
  //   "FunctionPlugin",
  //   "get_location",
  //   {
  //     key: "userInfo",
  //   }
  // );
}

// setTimeout(() => {
//   new Vue({
//   el: '#app',
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app');
// }, 5000);
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   render: h => h(App),
// }).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js